import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const getAuthToken = (state) => state.user.token

export const locationssApi = createApi({
    reducerPath: 'locationssApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_BASE_URL,
        prepareHeaders: (headers, { getState }) => {

            const token = getAuthToken(getState())

            if (token) headers.set(`Authorization`, `Bearer ${token}`)

            return headers
        }
    }),
    endpoints: (builder) => ({
        // getProposal: builder.query({
        //     query: (proposalId) => `/api/proposals/${proposalId}/proposalPortal`,
        // }),

        getLocations: builder.query({

            query: (queryPamramString) => `/api/locations/find?${queryPamramString}`,
            keepUnusedDataFor: 10

        })

    })
})

export const { useGetLocationsQuery } = locationssApi